import { Stack } from "@mui/material";
import { useRecordContext } from "ra-core";
import { FC } from "react";
import { RecPatch } from "@/dataProvider/tools";
import { DataCatalogResponseDto, SecondaryClassificationResponseDto } from "@/gen/api/governance";
import { useDataCatalogContext } from "../dataCatalogContext/DataCatalogContext";
import { SimpleOption } from "../search/AmbientFacilitiesContext";
import ClassificationLabel from "./ClassificationLabel";
import EncryptionRuleLabel from "./EncryptionRuleLabel";


interface FieldRowLabelsProps {
  classifications: SimpleOption[],  
}

const FieldRowLabels: FC<FieldRowLabelsProps> = ({
  classifications: clsOptions,
}) => {
  const field: DataCatalogResponseDto&RecPatch = useRecordContext()
  const classifications = clsOptions as SecondaryClassificationResponseDto[]

  const { getFieldEncryptRules } = useDataCatalogContext()

  if (!field) { return null }

  const cls = classifications.find(c => c.secondaryClassificationId === field.secondaryClassificationId)
  const encryptRule = getFieldEncryptRules(field).find(r => r.id === field.encryptionRuleId)
  return (
    <Stack direction="row" spacing={2} alignItems="center" sx={{ maxWidth: 560 }}>
      {cls && <ClassificationLabel variant={field.primaryClassification as any} text={cls.name || ''} />}
      {encryptRule && <EncryptionRuleLabel text={encryptRule.name || ''} />}
    </Stack>
  )
}

export default FieldRowLabels;
